<template>
  <section class="section" ref="section">
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="has-text-centered" style="margin-bottom: 1rem;">
          <span style="font-size: 1.75rem; font-weight: 700; letter-spacing: -0.5px; color: #3273dc;">Fooshi</span>
        </div>
        <div class="has-text-centered" style="margin-bottom: 1.5rem;">
          <LanguageSelector />
        </div>
        <OnboardingProgress :current-step="2" />
        <h3 class="title is-4 is-spaced is-centered">
          <span>{{ $t('onboarding.accountDetails.title') }}</span>
        </h3>
        <h4 class="title is-5 is-spaced is-centered">
          <span>{{ $t('onboarding.accountDetails.subtitle') }}</span>
        </h4>
        <div class="field">
          <label class="label">{{ $t('onboarding.accountDetails.shopName') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              :placeholder="$t('onboarding.accountDetails.shopNamePlaceholder')"
              ref="shopName"
              v-model="accountDetailsInfo.shopName"
              v-bind:class="{
                'is-danger': errors && (!accountDetailsInfo.shopName || failureNotification == 'onboarding.accountDetails.duplicatedVendorName'),
              }"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-building"></i>
            </span>
          </p>
          <p class="help is-danger"
            v-if="failureNotification == 'onboarding.accountDetails.duplicatedVendorName'"
            >
            {{ $t(failureNotification)}}
          </p>
        </div>
        <div class="field">
          <label class="label">{{ $t('onboarding.accountDetails.shopTypeLabel') }}</label>
          <div class="control" >
            <label class="radio">
              <input type="radio" name="shopType" value="producer" v-model="accountDetailsInfo.shopType" />
              {{ $t('onboarding.accountDetails.producer') }}
            </label>
            <label class="radio">
              <input type="radio" name="shopType" value="distributor" v-model="accountDetailsInfo.shopType" />
              {{ $t('onboarding.accountDetails.distributor') }}
            </label>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t('onboarding.accountDetails.shopEmail') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="email"
              :placeholder="$t('onboarding.accountDetails.emailPlaceholder')"
              v-model="accountDetailsInfo.email"
              @blur="validateEmail"
              v-bind:class="{
                'is-danger': (errors && !accountDetailsInfo.email) || failureNotification == 'onboarding.accountDetails.invalidEmailAddress'|| failureNotification == 'onboarding.accountDetails.duplicatedEmail',
              }"/>
            <span class="icon is-small is-left">
              <i class="fa fa-envelope"></i>
            </span>
            <span class="icon is-small is-right" v-if="false">
              <i class="fa fa-check"></i>
            </span>
          </p>
          <p class="help is-danger"
            v-if="failureNotification == 'onboarding.accountDetails.invalidEmailAddress' || failureNotification == 'onboarding.accountDetails.duplicatedEmail'"
            >
            {{ $t(failureNotification)}}
          </p>
          <p class="help">
            {{ $t('onboarding.accountDetails.emailHelp') }}
          </p>
        </div>
        <div class="field">
          <label class="label">{{ $t('onboarding.accountDetails.shipFromLabel') }}</label>
          <div class="control has-icons-left">
            <span class="select is-fullwidth" v-bind:class="{
                  'is-danger': errors && !accountDetailsInfo.shipFrom,
                }">
              <select v-model="accountDetailsInfo.shipFrom" style="width: 100%">
                <option></option>
                <option v-for="country in meta.countries" :key="country.id" :value="country.id">{{country.countryName}}</option>
              </select>
            </span>
            <span class="icon is-small is-left">
              <i class="fa fa-globe"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $t('onboarding.accountDetails.minCartLabel') }}</label>
          <div class="control has-icons-left">
            <div class="select is-fullwidth" v-bind:class="{
                  'is-danger': errors && !accountDetailsInfo.cartSize,
                }">
              <select v-model="accountDetailsInfo.cartSize" style="width: 100%">
                <option>{{ $t('onboarding.accountDetails.selectOption') }}</option>
                <option value="10">{{ $t('onboarding.accountDetails.cartSize10') }}</option>
                <option value="20">{{ $t('onboarding.accountDetails.cartSize20') }}</option>
                <option value="50">{{ $t('onboarding.accountDetails.cartSize50') }}</option>
                <option value="100">{{ $t('onboarding.accountDetails.cartSize100') }}</option>
              </select>
            </div>
              <span class="icon is-small is-left">
                <i class="fa fa-shopping-cart"></i>
              </span>
          </div>
          <p class="help">
            {{ $t('onboarding.accountDetails.minCartHelp') }}
          </p>
        </div>
        <div class="field">
          <label class="checkbox">
            <input type="checkbox" v-model="accountDetailsInfo.buildMyCatalogue" />
            {{ $t('onboarding.accountDetails.buildMyCatalogueCheckbox') }}
          </label>
        </div>
        <div class="field" v-if="accountDetailsInfo.buildMyCatalogue">
          <label class="label">{{ $t('onboarding.accountDetails.catalogueUrlLabel') }}</label>
          <p class="control has-icons-left">
            <input
              class="input"
              type="url"
              :placeholder="$t('onboarding.accountDetails.catalogueUrlPlaceholder')"
              v-model="accountDetailsInfo.catalogueUrl"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-link"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control">
            <primary-button class="is-fullwidth" :label="$t('app.buttons.saveAndContinue')" @click="submit()" :loading="!ready"></primary-button>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { FooshiApi } from '@/services/fooshiApi.service'
import { EmailValidator } from '@/services/emailValidator.service'
import { JwtCookie } from '../../services/jwtCookie.service.js'
import PrimaryButton from '../../components/forms/PrimaryButton.vue'
import LanguageSelector from '../../components/LanguageSelector.vue'
import OnboardingProgress from '@/components/OnboardingProgress.vue'

export default {
  components: {
    PrimaryButton,
    LanguageSelector,
    OnboardingProgress
  },
  methods: {
    validateEmail () {
      if (EmailValidator.isValid(this.accountDetailsInfo.email)) {
        this.failureNotification = ''
      } else {
        this.failureNotification = 'onboarding.accountDetails.invalidEmailAddress'
      }
    },
    async submit () {
      if (
        !this.accountDetailsInfo.shopName ||
        !this.accountDetailsInfo.shopType ||
        !this.accountDetailsInfo.email ||
        !this.accountDetailsInfo.shipFrom ||
        !this.accountDetailsInfo.cartSize
      ) {
        this.errors = true
      } else {
        this.ready = false
        await this.addAcountDetails()
        this.ready = true
      }
    },
    async addAcountDetails () {
      this.errors = false
      const response = await FooshiApi.addAccountDetails({
        name: this.accountDetailsInfo.shopName,
        slug: this.accountDetailsInfo.shopName.toLowerCase().split(' ').join('-'),
        type: this.accountDetailsInfo.shopType,
        vendorEmail: this.accountDetailsInfo.email,
        pointofSale: this.accountDetailsInfo.shipFrom,
        minCart: this.accountDetailsInfo.cartSize,
        commission: 0.2,
        b2b: true,
        buildMyCatalogue: this.accountDetailsInfo.buildMyCatalogue || null,
        catalogueUrl: this.accountDetailsInfo.catalogueUrl || null
      })
      if (response.success) {
        if (window.plausible) window.plausible('Onboarding Step Completed', { props: { stage: 'activation', step: 'account-details', vendor_type: this.accountDetailsInfo.shopType } })
        // Update JWT token step
        const onboardingStatus = await FooshiApi.getOnboardingStatus()
        this.step = onboardingStatus.data.step
        JwtCookie.setJwtCookie('fooshistep', this.step, 365)
        this.$router.push('account-details-owner')
      } else {
        this.errors = true
        this.failureNotification = Array.isArray(response.message) ? response.message[0] : response.message
      }
    },
    async fetchCountries () {
      var response = await FooshiApi.getCountries({ includeAll: true })
      if (response.status) {
        this.meta.countries = response.data
        this.meta.countries.sort((a, b) => {
          return a.countryName.localeCompare(b.countryName)
        })
      }
    }
  },
  async mounted () {
    await this.fetchCountries()
    this.ready = true
    this.$nextTick(() => {
      this.$refs.shopName.focus()
    })
  },
  data () {
    return {
      ready: false,
      errors: false,
      failureNotification: '',
      step: '',
      accountDetailsInfo: {
        shopName: '',
        shopType: 'distributor',
        shipFrom: '',
        email: '',
        buildMyCatalogue: false,
        catalogueUrl: ''
      },
      meta: {
        countries: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/onBoarding/AccountDetails.vue